import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: '¿Necesito una computadora moderna para aplicar esto?',
  answer: 'NO. Hemos diseñado todo el sistema para que el 100% del Masterkit, y todas las herramientas de Inteligencia Artificial que te recomendamos, puedan usarse directamente desde el navegador de tu celular inteligente. No necesitas equipos costosos.'
}, {
  question: '¿Cómo puedo pagar si estoy en Venezuela y no tengo tarjeta?',
  answer: "¡Pensamos exactamente en ti! Al hacer clic en el botón de compra, podrás seleccionar 'Pago Móvil' y pagar en bolívares (el monto se calcula automáticamente a la tasa BCV del día). También aceptamos Binance Pay (USDT) si prefieres usar criptos."
}, {
  question: '¿Cómo y cuándo recibo el acceso al producto?',
  answer: 'Si pagas con tarjeta de crédito/débito, el acceso llega a tu correo automáticamente en segundos. Si eliges Pago Móvil o Binance, solo completas tu pedido en la página, nos pasas la captura al WhatsApp que te indicaremos, y te liberamos el acceso de inmediato.'
}, {
  question: '¿Tengo que pagar suscripciones costosas en ChatGPT?',
  answer: 'Absolutamente NO. Te enseñamos a exprimir al máximo las versiones gratuitas de ChatGPT y Claude. Además, te entregamos una Toolbox secreta con alternativas sin costo que no te pedirán tarjeta de crédito para registrarte.'
}, {
  question: '¿Soy muy principiante, podré entenderlo y conseguir clientes?',
  answer: "¡Sí! El material está diseñado 'A prueba de novatos' para llevarte desde CERO absoluto hasta tu primer cliente. No usamos jerga técnica complicada ni te enseñamos a programar. Todo se basa en seguir nuestra regla de oro: 'Copiar y Pegar'."
}, {
  question: '¿Qué pasa si no me funciona o no me gusta?',
  answer: 'Cuentas con nuestra Garantía Blindada de 7 días. Si después de aplicar el Masterkit no sientes que tienes las herramientas necesarias para empezar a generar ingresos con clientes internacionales, te devolvemos tus $14.99 sin hacer preguntas. El riesgo es todo nuestro.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-[#050505] relative z-10 border-t border-white/5" data-id="element-334">
      {/* Resplandor de fondo sutil */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[300px] bg-cyan-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-335" />

      <div className="container mx-auto px-4 max-w-3xl relative z-20" data-id="element-336">
        <div className="text-center mb-12" data-id="element-337">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-338">
            PREGUNTAS{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 drop-shadow-[0_0_15px_rgba(6,182,212,0.3)]" data-id="element-339">
              FRECUENTES
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg font-light" data-id="element-340">
            Despejamos tus últimas dudas antes de empezar tu transformación
            digital.
          </motion.p>
        </div>

        <div className="space-y-4" data-id="element-341">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-cyan-500/50 bg-[#0a1628] shadow-[0_0_20px_rgba(6,182,212,0.15)]' : 'border-white/10 bg-[#0a0a0a] hover:border-cyan-500/30'}`} data-id="element-342">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-343">
                <span className={`text-base md:text-lg font-bold pr-8 transition-colors ${openIndex === index ? 'text-cyan-300' : 'text-white'}`} data-id="element-344">
                  {faq.question}
                </span>
                <span className={`flex-shrink-0 p-2 rounded-full transition-colors ${openIndex === index ? 'bg-cyan-500 text-white shadow-[0_0_10px_#06b6d4]' : 'bg-cyan-500/10 text-cyan-400'}`} data-id="element-345">
                  {openIndex === index ? <Minus className="w-5 h-5" data-id="element-346" /> : <Plus className="w-5 h-5" data-id="element-347" />}
                </span>
              </button>

              <AnimatePresence data-id="element-348">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-349">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-white/5 pt-4 font-light text-sm md:text-base" data-id="element-350">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}